import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, catchError, retry } from 'rxjs';
import { environment } from '../../environments/environment';

export interface MilestonePlanTask {
  id: string;
  projectId: string;
  taskNumber: string;
  task: string;
  deliverable?: string;
  startDate: string;
  targetDate?: string;
  actualDate?: string;
  status: string;
  comments?: string;
  displayOrder: number;
}

export interface CreateMilestonePlanTaskDto {
  projectId: string;
  taskNumber: string;
  task: string;
  deliverable?: string;
  startDate: string;
  targetDate?: string;
  actualDate?: string;
  status: string;
  comments?: string;
  displayOrder: number;
}

@Injectable({
  providedIn: 'root'
})
export class MilestonePlanTaskService {
  private apiUrl = `${environment.apiUrl}/MilestonePlanTask`;

  constructor(private http: HttpClient) { }

  getByProjectId(projectId: string): Observable<MilestonePlanTask[]> {
    return this.http.get<MilestonePlanTask[]>(`${this.apiUrl}/project/${projectId}`);
  }

  getById(id: string): Observable<MilestonePlanTask> {
    return this.http.get<MilestonePlanTask>(`${this.apiUrl}/${id}`);
  }

  addTask(task: CreateMilestonePlanTaskDto): Observable<MilestonePlanTask> {
    return this.http.post<MilestonePlanTask>(this.apiUrl, task);
  }

  updateTask(id: string, task: MilestonePlanTask): Observable<MilestonePlanTask> {
    return this.http.put<MilestonePlanTask>(`${this.apiUrl}/${id}`, task);
  }

  deleteTask(id: string): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  reorderTask(id: string, newDisplayOrder: number): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/${id}/reorder`, { newDisplayOrder });
  }
}


